export { OnboardingView } from './OnboardingView';
